import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  Timestamp
} from "firebase/firestore";
import { db } from "./firebase";

export default function AdminCompetitionViewer() {
  const [comps, setComps] = useState([]);

  const fetchAllCompetitions = async () => {
    try {
      const snapshot = await getDocs(collection(db, "competitions"));
      const list = snapshot.docs.map((docSnap) => {
        const data = docSnap.data();
        const isValidTimestamp = data.timestamp && typeof data.timestamp.toDate === "function";

        // 🔍 Logging timestamp for inspection
        console.log("Fetched comp:", {
          id: docSnap.id,
          raw: data.timestamp,
          valid: isValidTimestamp
        });

        return {
          id: docSnap.id,
          discipline: data.discipline,
          category: data.category,
          dance: data.dance,
          timestamp: data.timestamp,
          isTimestampValid: isValidTimestamp
        };
      });
      setComps(list);
    } catch (err) {
      console.error("❌ Error fetching competitions:", err);
    }
  };

  useEffect(() => {
    fetchAllCompetitions();
  }, []);

  const correctTimestamp = async (compId, originalValue) => {
    try {
      let correctedDate;

      if (originalValue?.seconds) {
        correctedDate = new Date(originalValue.seconds * 1000);
      } else {
        correctedDate = new Date(originalValue);
      }

      correctedDate.setUTCHours(0, 0, 0, 0);
      const fixedTimestamp = Timestamp.fromDate(correctedDate);

      await updateDoc(doc(db, "competitions", compId), {
        timestamp: fixedTimestamp
      });

      console.log(`✅ Timestamp corrected for ${compId}`);
      setComps([]); // reset before fetch
      setTimeout(fetchAllCompetitions, 250); // allow Firestore update to propagate
    } catch (err) {
      console.error(`❌ Failed to update timestamp for ${compId}`, err);
      alert(`❌ Failed to update timestamp for ${compId}`);
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>📊 Admin Competition Viewer</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Discipline</th>
            <th>Category</th>
            <th>Dance</th>
            <th>Timestamp</th>
            <th>✔️ Valid?</th>
          </tr>
        </thead>
        <tbody>
          {comps.map((c, i) => (
            <tr key={i} style={{ background: c.isTimestampValid ? "white" : "#ffe6e6" }}>
              <td>{c.id}</td>
              <td>{c.discipline}</td>
              <td>{c.category}</td>
              <td>{c.dance}</td>
              <td>
                {c.timestamp?.toDate
                  ? c.timestamp.toDate().toISOString()
                  : String(c.timestamp)}
              </td>
              <td>
                {c.isTimestampValid ? (
                  "✅"
                ) : (
                  <>
                    ❌{" "}
                    <button
                      onClick={() => correctTimestamp(c.id, c.timestamp)}
                      style={{
                        marginLeft: "8px",
                        fontSize: "0.8rem",
                        padding: "4px 8px",
                        cursor: "pointer"
                      }}
                    >
                      Fix
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
